import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ToxOffering from "@/pages/ToxOffering";

export const Route = createFileRoute("/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-medioambientales-era")({
  head: () => buildRouteHead("/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-medioambientales-era"),
  component: ToxOffering,
});

